export const fr = {
  nav: { home: "Accueil", pricing: "Tarifs", demo: "Démo", signin: "Se connecter avec LinkedIn", signout: "Se déconnecter" },
  hero: { title: "Boostez votre portée LinkedIn avec des pods privés, invisibles", subtitle: "Nous vous assignons à des pods existants en coulisses. Zéro automatisation. Rotation équitable, quotas journaliers et points pour encourager l'engagement de qualité." },
  cta: { pricing: "Voir les tarifs", demo: "Voir la démo" },
  features: {
    invite: { title: "Qualité sur invitation", desc: "Matching invisible vers des pods curés." },
    fair: { title: "Équitable et conforme", desc: "Clic manuel vers LinkedIn. Jamais de bots." },
    points: { title: "Points et limites", desc: "2 soumissions/jour. Like=1, Commentaire=3." }
  },
  how: { title: "Comment ça marche", step1: "1. Demandez l'accès et onboardez-vous.", step2: "2. Nous vous affectons automatiquement à des pods existants.", step3: "3. Partagez, engagez manuellement, gagnez des points, développez votre reach." },
  compliance: { title: "Conformité", copy: "Jamais d'automatisation des likes/commentaires. Les utilisateurs cliquent toujours vers LinkedIn. Le matching et la rotation sont côté serveur dans le respect des CGU." },
  faq: {
    title: "FAQ",
    platforms_q: "Quelles plateformes ?",
    platforms_a: "LinkedIn uniquement pour la v1.",
    submissions_q: "Combien de soumissions ?",
    submissions_a: "Jusqu'à 2 soumissions actives par jour.",
    points_q: "Calcul des points ?",
    points_a: "Like = 1 point, Commentaire = 3 points. Un minimum est requis pour soumettre."
  },
  pricing: {
    title: "Des tarifs simples",
    subtitle: "Choisissez un plan et demandez l'accès. Résiliable à tout moment.",
    starter: "Starter",
    pro: "Pro",
    team: "Team",
    price_starter: "19€/mois",
    price_pro: "49€/mois",
    price_team: "Contact",
    feat_curated: "Pods curés",
    feat_priority: "Matching prioritaire",
    feat_analytics_basic: "Analytics basiques",
    feat_analytics_adv: "Analytics avancés",
    feat_seats: "Multiples sièges",
    feat_limits: "Limites personnalisées",
    feat_sla: "Support SLA",
    cta: "Demander l'accès"
  },
  demo: {
    title: "Démo (lecture seule)",
    subtitle: "Illustration du flux d'engagement manuel et du système de points.",
    queue_title: "File d'engagement",
    points_title: "Aperçu des points",
    open: "Ouvrir"
  },
  footer: { copy: "© EngagePods. v1 LinkedIn uniquement. Pods sur invitation." }
} as const;
